import React, { createContext, useContext, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const BrandMark = () => (
  <img src="/logo-full.png" alt="GjejShqip" style={{ height: 34, width: "auto" }} draggable={false} />
);

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  const [value, setValue] = useState("");

  const confirm = useCallback((opts = {}) => new Promise((resolve) => {
    setValue("");
    setState({ input: false, confirmText: "Po", danger: true, ...opts, resolve });
  }), []);

  const prompt = useCallback((opts = {}) => new Promise((resolve) => {
    setValue(opts.defaultValue || "");
    setState({ input: true, confirmText: "Ruaj", danger: false, ...opts, resolve });
  }), []);

  const finish = (result) => { if (state) state.resolve(result); setState(null); };
  const onCancel = () => finish(state?.input ? null : false);
  const onConfirm = () => {
    if (state?.input && state?.required && !value.trim()) return;
    finish(state?.input ? value.trim() : true);
  };

  return (
    <ConfirmContext.Provider value={{ confirm, prompt }}>
      {children}
      <Dialog open={!!state} onOpenChange={(o) => { if (!o) onCancel(); }}>
        <DialogContent className="max-w-xs rounded-3xl p-5" data-testid="confirm-dialog">
          <DialogTitle className="sr-only">{state?.title || "Konfirmim"}</DialogTitle>
          <div className="flex justify-center mb-2"><BrandMark /></div>
          {state?.title && <h3 className="text-center text-lg font-extrabold text-slate-900">{state.title}</h3>}
          {state?.message && <p className="text-center text-sm text-slate-500 mt-1">{state.message}</p>}
          {state?.input && (
            <input
              data-testid="confirm-input" autoFocus type={state.type || "text"} value={value} onChange={(e) => setValue(e.target.value)}
              placeholder={state.placeholder || ""}
              onKeyDown={(e) => e.key === "Enter" && onConfirm()}
              className="w-full mt-3 bg-slate-100 rounded-xl h-11 px-3 text-sm outline-none"
            />
          )}
          <div className="flex gap-2 mt-4">
            <button data-testid="confirm-cancel" onClick={onCancel} className="flex-1 h-11 rounded-xl bg-slate-100 text-slate-600 font-semibold text-sm">Anulo</button>
            <button data-testid="confirm-ok" onClick={onConfirm} className={`flex-1 h-11 rounded-xl text-white font-semibold text-sm ${state?.danger ? "bg-red-500" : "bg-emerald-500"}`}>{state?.confirmText || "Po"}</button>
          </div>
        </DialogContent>
      </Dialog>
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmContext);
